import type { ReactNode } from 'react';

import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import CloseIcon from '../icons/CloseIcon';

import { Box } from '../box/box';
import { Button } from '../button/button';
import { Text } from '../text/text';

import { buttonPadding, variantConfig } from './utils';

import * as styles from './tag.css';

type DismissProps =
  | {
      onDismiss: () => void;
      onDismissText: ReactNode;
    }
  | {
      onDismiss?: never;
      onDismissText?: never;
    };

export type TagProps = DismissProps & {
  variant?: keyof typeof styles.variant;
  size?: keyof typeof buttonPadding;
  expand?: boolean;
  children: ReactNode;
  'data-testid'?: string;
};

const TEST_IDS = {
  TAG: 'tag-component',
  TEXT: 'tag-component-text',
};

export const Tag = ({
  children,
  variant = 'default',
  size = 'medium',
  onDismiss,
  onDismissText,
  expand = false,
  'data-testid': testId = TEST_IDS.TAG,
}: TagProps) => (
  <Box
    padding={buttonPadding[size].box}
    rounded
    size={!expand ? { maxWidth: 'basePos12' } : undefined}
    className={classFilter([styles.size[size]])}
    variant="inline-flex"
    alignContent={{ y: 'center' }}
    data-testid={testId}
    background={variantConfig[variant]}
  >
    <Box constrain="hidden">
      <Text
        truncate
        variant={size === 'small' ? 'captionSmall' : 'caption'}
        padding={buttonPadding[size].text}
        data-testid={TEST_IDS.TEXT}
      >
        {children}
      </Text>
    </Box>

    {onDismiss ? (
      <Button variant="icon" onClick={onDismiss} Icon={CloseIcon} size="small">
        {onDismissText}
      </Button>
    ) : null}
  </Box>
);
